import i from "clsx";
import e from "react";
import { s as r } from "../../../../../RideGlyph.module-CgKw9y7i.mjs";
function h({
  size: t = "small",
  accessibilityTitle: l = "glyph document solid",
  className: o,
  "data-testid": s,
  fill: a,
  stroke: m
}) {
  const n = () => i(o, r["ride-glyph"], {
    [r[`size-${t}`]]: t
  });
  return /* @__PURE__ */ e.createElement("div", { className: n(), "data-testid": s }, /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "32",
      height: "32",
      viewBox: "0 0 32 32",
      fill: a || "#03050F",
      stroke: m || "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    l && /* @__PURE__ */ e.createElement("title", null, l),
    /* @__PURE__ */ e.createElement("path", { d: "M19.003 5.63023L24.4626 12.0006H20.005C19.7393 12.0006 19.4844 11.8951 19.2965 11.7072C19.1086 11.5193 19.003 11.2644 19.003 10.9987V5.63023ZM25.0034 13.9989V28.0035H7.00232V10.0138C7.00382 8.69057 7.52935 7.4218 8.46395 6.48507C9.39855 5.54834 10.6661 5.0199 11.9893 5.01538H17.0048V11.0101C17.0048 11.8058 17.3209 12.5689 17.8835 13.1315C18.4462 13.6941 19.2093 14.0102 20.005 14.0102L25.0034 13.9989ZM20.005 19.9992H12.0349V22.0031H20.005V19.9992ZM20.005 16.0141H12.0349V18.0124H20.005V16.0141Z" })
  ));
}
export {
  h as RideGlDocumentSolid
};
